import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/60050673-0a0e3c80-9686-11e9-911a-c27e78e0ca51.png",
        "alt": "color system"
      }}></img></p>
    <p>{`Primer Presentations uses the same `}<a parentName="p" {...{
        "href": "https://primer.style/css/support/color-system"
      }}>{`color system`}</a>{` as GitHub.
For presentations created on an Apple computer, the color system is available as a color palette file that can be imported for use with the macOS system-wide color picker. This is packaged together with the `}<a parentName="p" {...{
        "href": "https://drive.google.com/open?id=1Wp3NyCYM-FsU-4MKSbPcBgIsWVgvUQy0"
      }}>{`Keynote template download`}</a>{`. Instructions on how to import the color palette are found below.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`1. Download the `}<a parentName="td" {...{
              "href": "https://drive.google.com/open?id=1Wp3NyCYM-FsU-4MKSbPcBgIsWVgvUQy0"
            }}>{`Keynote`}</a>{` template.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2. Open Keynote and the color picker with `}<strong parentName="td">{`View`}</strong>{` > `}<strong parentName="td">{`Show Colors`}</strong>{` (or `}<kbd>{`Cmd`}</kbd>{`+`}<kbd>{`Shift`}</kbd>{`+`}<kbd>{`C`}</kbd>{`). Click the gear icon and `}<strong parentName="td">{`Open...`}</strong>{` to load the palette.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img width="640" alt="The gear icon will show a context menu with the options of new, open, rename, and remove" src="https://cloud.githubusercontent.com/assets/98681/26179462/b9662e34-3b18-11e7-9e43-9684f690e9c3.png" /></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`3. Navigate to the downloaded folder and select the `}<inlineCode parentName="td">{`colors/github.clr`}</inlineCode>{` file in this repository.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/60049637-8e12f500-9683-11e9-9220-6c98fe2cc6f5.png",
              "alt": "GitHub color palettes are included in your Keynote download."
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`4. Colors are installed! You can now use the Primer color palette within Keynote.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img width="326" alt="screenshot of the apple color picker with the primer color palette installed" src="https://cloud.githubusercontent.com/assets/98681/26179461/b95bc30e-3b18-11e7-92f3-725e35f20ecb.png" /></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      